import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
        <span className="text-6xl font-bold text-primary-500 font-heading">404</span>
        <h1 className="mt-4 text-xl md:text-2xl font-semibold text-foreground-100">页面走丢了</h1>
        <p className="mt-2 text-sm text-foreground-400">你访问的页面不存在或已被移除</p>
        <div className="mt-7 flex flex-col sm:flex-row gap-3">
          <Link
            to="/"
            className="rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/category"
            className="rounded-md border border-background-600 px-5 py-2.5 text-sm font-medium text-foreground-100 hover:border-primary-500 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览短剧分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}